import { Sparkle, Star5, Heart, Rainbow } from "./glyphs";

/**
 * Scattered decorative glyphs for the Sparkle theme. Always rendered but
 * CSS-gated — hidden under kovach-steele, shown under [data-theme="sparkle"]
 * (see .sparkle-decor in index.css). Fixed to the right/bottom margins and
 * non-interactive, so it never blocks content. Reduced-motion safe (static).
 */
export function SparkleDecor() {
  return (
    <div className="sparkle-decor pointer-events-none fixed inset-0 z-40 hidden" aria-hidden="true">
      <Star5 size={14} color="#00D5E0" style={{ position: "fixed", top: 84, right: 26, opacity: 0.9 }} />
      <Sparkle size={16} color="#FFD400" style={{ position: "fixed", top: "42%", right: 16, opacity: 0.8 }} />
      <Heart size={13} color="#FF2D9B" style={{ position: "fixed", bottom: 84, right: 30, opacity: 0.85 }} />
      <Rainbow width={54} style={{ position: "fixed", bottom: 14, right: 14, opacity: 0.8 }} />
    </div>
  );
}
